import { useCallback, useEffect } from 'react';
import Crashes from '@capacitor-community/appcenter-crashes';
import { Device } from '@capacitor/device';
import { TrackerCustomEvent } from 'common-package';
import * as SentryCapacitor from '@sentry/capacitor';
import dayjs from 'dayjs';
import { App } from '@capacitor/app';
import semver from 'semver';
import lookie from 'lookie';
import { CURRENT_ANDROID_ID } from '@/constant';
import service from '@/service';
import { useTracker } from './index';

const useAppCrash = () => {
  const { sendEvent } = useTracker();

  useEffect(() => {
    if (sendEvent) {
      setTimeout(() => init(), 1000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendEvent]);

  const init = useCallback(async () => {
    try {
      const deviceInfo = await Device.getInfo();
      if (deviceInfo?.platform === 'web') return;

      const appInfo = await App.getInfo();

      // app打包版本低于1.5.0或者大于1.6.0则不处理崩溃日志
      if (semver.lt(appInfo?.version, '1.5.0') || semver.gt(appInfo?.version, '1.6.0')) {
        return;
      }

      const isEnabled = await Crashes.isEnabled();
      if (!isEnabled.value) {
        await Crashes.setEnabled({ enable: true });
      }
      const hasCrashedInLastSession = await Crashes.hasCrashedInLastSession();
      if (hasCrashedInLastSession.value) {
        console.log('当前记录到相关崩溃日志，执行上传。。。');

        const errReport = await Crashes.lastSessionCrashReport();
        const hasMemoryWarning = await Crashes.hasReceivedMemoryWarningInLastSession();

        try {
          const androidId = lookie.get(CURRENT_ANDROID_ID);
          const crashTime = dayjs().format('YYYY-MM-DD HH:mm:ss');

          await service.system.logCrash({
            ...(deviceInfo || {}),
            crashTime,
            androidId,
            log:
              JSON.stringify(errReport.value || {}) +
              `hasReceivedMemoryWarningInLastSession: ${hasMemoryWarning?.value}`,
          });

          sendEvent(TrackerCustomEvent.CrashLog, {
            et: 'CRASH',
            c1: androidId,
            c2: crashTime,
            c3: deviceInfo,
            c4: {
              primary: errReport?.value,
              hasReceivedMemoryWarningInLastSession: hasMemoryWarning?.value,
            },
          });
          SentryCapacitor.captureException(errReport?.value);
        } catch (e) {
          console.log('上传崩溃日志失败', e);
        }
      } else {
        console.log('当前未检查到崩溃日志');
      }
    } catch (e) {
      console.log('[useAppCrash Error]: ', e);
    }
  }, [sendEvent]);
};

export default useAppCrash;
